export interface Label {
  id: string;
  name: string;
  color: string | null;
}

export interface AccessRole {
  id: string;
  name: string;
}

export interface TeamToolUrl {
  id: string;
  teamToolId: string;
  name: string;
  url: string;
  notes: string | null;
  createdAt: string;
}

export interface TeamTool {
  id: string;
  teamId: string;
  toolId: string;
  notes: string | null;
  team: {
    id: string;
    name: string;
    color: string;
  };
  urls: TeamToolUrl[];
}

export interface ToolJiraProjectUrl {
  id: string;
  toolJiraProjectId: string;
  name: string;
  url: string;
  notes: string | null;
  createdAt: string;
}

export interface JiraTeam {
  id: string;
  toolId: string;
  jiraProjectId: string;
  notes: string | null;
  jiraProject: {
    id: string;
    key: string;
    name: string;
    avatarUrl: string | null;
  };
  urls: ToolJiraProjectUrl[];
}

export interface Tool {
  id: string;
  name: string;
  url: string | null;
  description: string | null;
  authMethod: string | null;
  accessProvider: string | null;
  notes: string | null;
  renewalDate: string | null;
  renewalNotes: string | null;
  isPaid: boolean;
  createdAt: string;
  updatedAt: string;
  labels: Array<{ toolId: string; labelId: string; label: Label }>;
  accessRoles: Array<{
    toolId: string;
    accessRoleId: string;
    accessRole: AccessRole;
  }>;
  teamTools: TeamTool[];
  jiraTeams: JiraTeam[];
}

export const AUTH_METHOD_LABELS: Record<string, string> = {
  okta: "Okta",
  email_password: "Email / Password",
  sso: "SSO",
  api_key: "API Key",
  other: "Other",
};

export const AUTH_METHODS = Object.keys(AUTH_METHOD_LABELS);
